module.exports = __webpack_public_path__ + "img/3.4d5c801a.png";